import { useEffect, useState } from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { thumbnailPlugin } from '@react-pdf-viewer/thumbnail';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/thumbnail/lib/styles/index.css';
import { Flex, Image, Space, Tooltip, Modal, Badge, Card } from "antd";
import { IconPin } from 'components/assets/icons';
import { SimpleModal } from 'components/containers';
import { FillButton, RoundTag, RoundSmallTag, NewTag } from "components/elements";

/**
 * 
 * @returns 
 */
export const ClassItem = ({ src, width = '198px', height = '138px', title = '', content = '', isNew, isPin, onClick }) => {
  const [modal, setModal] = useState(false);
  
  return (
    <>
      <div className='class-item-wrap'>  
      <div className='class-item'>  
        <div className="class-item-pin">
          {isPin === 1 && <IconPin />}
        </div>
        <Image preview={true} src={src} width={'auto'} height={height} alt="" />
        {/* <div className='class-item-content'>{content}</div>  */}
        <div onClick={() => {
            if(onClick) onClick();
          }} style={{cursor: onClick&&'pointer'}}>
          <div className='class-item-title' >
            {title}
            {isNew && <RoundTag label='New' color='blue' />}
          <div className='class-item-content'>{content}</div> 
          </div>
        </div>
      </div>
      </div>

    </>
  )
};

export const ClassItem1 = ({ file_path, width = '150px', height = '190px', title = '', content = '', isNew, isPin, isDisplay, onClick }) => {
  const [modal, setModal] = useState(false);
  let header = <Space onClick={() => { if(onClick) onClick();}} >
    <span>{isPin === 1 && <IconPin />} {title}</span>
  </Space>;
  const css_arr = ['text-click','bg-gray'];
  if(isDisplay > 1) css_arr.push('non-display')
  return (
    <>
    <Space direction="vertical" size="small" style={{ width: '190px' }}>
      {isNew>0 ?
        <Badge.Ribbon text={isNew>0 && "NEW"}>
          <Card title={header} size="small" className={`${css_arr.join(' ')}`} hoverable>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                <div
                    className="rpv-core__viewer text-click"
                    style={{
                        display: 'flex',
                        margin: '2px 0px',
                        width: '170px',
                        height: '180px',
                        position: 'relative'

                    }}
                    onClick={ ()=>setModal(true)}
                >
                  <span style={{
                    width:'200px', 
                    height:'160px', 
                    position:'absolute',
                  }}>
                {file_path && <iframe src={file_path[0]} width={width} height={height} style={{position:'absolute'}} scrolling="no"> </iframe> }
                  </span>
                <div style={{
                    width:'150px', 
                    height:'190px', 
                    position:'absolute',
                  }} onClick={ ()=>setModal(true)}>
                </div>
                
              </div>
            </Worker>

          </Card>
        </Badge.Ribbon>
        :
        <Badge>
          <Card title={header} size="small" className={`${css_arr.join(' ')}`}>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                <div
                    className="rpv-core__viewer text-click"
                    style={{
                        margin: '0px 0px 7px',
                        width: '150px',
                        height: '180px',
                        position: 'relative'
                    }}
                    onClick={ ()=>setModal(true)}
                >
                {file_path && <>
                  <iframe src={file_path[0]} width={width} height={height} style={{position:'absolute'}} scrolling="no"> </iframe>
                  <div style={{
                    width:'200px', 
                    height:'160px', 
                    position:'absolute',
                  }} onClick={ ()=>setModal(true)}>
                </div>
                </>}
              </div>
            </Worker>
          </Card>
        </Badge>

      }
    </Space>
    
    <Modal className='bord-class-pdf-modal'
        open={modal} 
        title={<Flex justify='center' gap='small'>
                <FillButton label='인쇄' backgroundColor={'var(--color-gray03)'} onClick={()=>window.open(file_path[0])}/>
                <FillButton label='닫기' color={'var(--color-gray03)'} backgroundColor={'var(--color-gray04)'} onClick={() => setModal(false)} />
              </Flex>}
        width='70%'
        height='90%'
        closable={true}
        onCancel={() => setModal(false)}
        styles={{    
          header: {
            paddingInlineStart: 22,
            display: 'flex',
            justifyContent:'center',
            alignItems: 'center',
            height: '60px',
            borderBottom: '1px solid var(--color-gray08)',
          },
          title: {
          },
          content: {
            padding: '0px 0px 22px 0px',
            height:'100%',
          },
          body: {
            padding: '22px',
            overflowY: 'auto',
            height:'calc(100% - 60px)'
          }
        }}
        footer={[<></>,]}
      >
        <div className='class-item-content' dangerouslySetInnerHTML={ {__html: content } }></div>
        {file_path?.map(item=>{
          const temp = item.split('.');
          if(temp[temp.length-1] === 'pdf') {
            //  <iframe src={item} height={'100%'} width={'100%'} />
            return <iframe src={item} height={'100%'} width={'100%'} />
          }
        })
        }
      </Modal>
    </>
  )
};

export const ClassItem2 = ({ src, file_path, width = '198px', height = '162px', title = '', content = '', isNew, isPin, onClick }) => {
  const [modal, setModal] = useState(false);
  return (
    <div style={{width:'200px'}}>
      {/* <div className='class-item-wrap'>   */}
        <div className='class-item'>  
          <div className="class-item-pin">
            {isPin === 1 && <IconPin />}
          </div>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
              <div
                  className="rpv-core__viewer text-click"
                  style={{
                      display: 'flex',
                      height: '160px',
                      width: '100%',
                      position: 'relative'
                  }}
              >
                <iframe src={file_path[0]} width={width} height={height} style={{position:'absolute'}}  scrolling="no"> </iframe>
                <div style={{
                    width:'200px', 
                    height:'160px', 
                    position:'absolute',
                  }} onClick={ ()=>setModal(true)}>
                </div>
                {/* <Viewer fileUrl={src}  /> */}
              </div>
          </Worker>
          <div className='class-item-content' dangerouslySetInnerHTML={ {__html: content } }>
          </div>
        </div>
        <div className='class-item-desc' onClick={() => {
            if(onClick) onClick();
          }} style={{cursor: onClick&&'pointer'}}>
            <Tooltip title={title}>
              <div className='class2-item-title'>
                <span className='text-hover'>{title}</span>
                {isNew && <NewTag /> }
              </div>
            </Tooltip>
        </div>
      {/* </div> */}

    <Modal
      title={<Space size='small'>
              <FillButton label='인쇄' backgroundColor={'var(--color-gray03)'} onClick={()=>window.open(file_path[0])}/>
              <FillButton label='닫기' color={'var(--color-gray03)'} backgroundColor={'var(--color-gray04)'} onClick={() => setModal(false)} />
            </Space>}
      open={modal} 
      width='70%'
      closable={true}
      onCancel={() => setModal(false)}
      styles={{    
        header: {
          paddingInlineStart: 22,
          display: 'flex',
          justifyContent:'center',
          alignItems: 'center',
          height: '60px',
          borderBottom: '1px solid var(--color-gray08)',
        },
        title: {
        },
        content: {
          padding: '0px 0px 22px 0px',
        },
        body: {
          padding: '22px',
          overflowY: 'auto',
          height:'700px'
        }
      }}
      footer={[
          <></>,
      ]}
    >
      <div className='class-item-content' dangerouslySetInnerHTML={ {__html: content } }></div>
      {file_path.map(it=><iframe src={it} height={'700px'} width={'100%'}> </iframe>)}

      {/* <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <Flex justify='center' gap='small' vertical>
              <div
                  className="rpv-core__modal_viewer"
                  style={{
                    display: 'flex',
                    height: '95%',
                    width: '500px'
                  }}
                  >
                  {file_path.map(src=><Viewer fileUrl={src}  />)}
              </div>
          </Flex>
        </Worker> */}
    </Modal>

    </div>
  )
};
